<template>
	<div class="notetemplate">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;">买家须知</div>
					<div class="contentcard">

						<a-row :gutter="16">
							<a-col :span="8" style="margin-bottom: 20px;" v-for="(item,index) in notetemplatelist" :key="index">
								<a-card hoverable style="border-radius: 5px;overflow: hidden;">
									<div style="height: 121px;overflow: hidden;">
										<p style="font-size: 16px;">{{item.note_title}}</p>
										<p>{{item.note_text}}</p>
									</div>
									<template class="ant-card-actions" slot="actions">
										<span @click="edit(item)">编辑</span>
										<span @click="del(item)">删除</span>
									</template>
								</a-card>
							</a-col>
							<a-col :span="8" style="margin-bottom: 20px;">
								<a-card hoverable style="border-radius: 5px;overflow: hidden;" @click="creatnotice">
									<div style="height: 167px;overflow: hidden;">
										<span style="line-height: 165px; text-align: center;display: block;font-size: 18px;">
											<a-icon type="plus" /> 新增模板</span>
									</div>
								</a-card>
							</a-col>
						</a-row>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal :title="istitle" :visible="isvisible" @ok="onOk(tempnotice)" :maskClosable="false" @cancel="onCancel" :width="900">
			<a-input v-model="tempnotice.note_title" style="width: 200px;" placeholder="模板名称"></a-input>
			<a-divider dashed />
			<div style="max-height: 300px; overflow-y: scroll;">
				<a-input v-model="tempnotice.note_text" type="textarea" rows="4" placeholder="请输入内容"></a-input>
			</div>
			<div style="margin-top: 20px;font-size: 10px;">
				<div>模板代码:</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>订单号:</span><span>{trade_number}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>发货产品名称:</span><span>{order_sku_title}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>物流单号:</span><span>{delivery_number}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>物流公司英文名:</span><span>{delivery_express_name}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>物流公司中文名:</span><span>{delivery_express_display}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>收件人手机号:</span><span>{trade_receiver_phone}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>收件人姓名:</span><span>{trade_receiver_name}</span>
				</div>
				<div style="display: inline-block;margin-right:15px;">
					<span>收货地址:</span><span>{trade_receiver_address}</span>
				</div>
			</div>
		</a-modal>

	</div>

</template>

<script>
	import {
		Icon,
		Button,
		Menu,
		Layout,
		Input
	} from 'ant-design-vue';
	// import axios from 'axios';

	export default {
		components: {
			[Icon.name]: Icon,
			[Button.name]: Button,
			[Menu.name]: Menu,
			[Layout.name]: Layout,
			[Input.name]: Input,
		},

		data() {
			return {
				current: ['transactionlist'],
				openKeys: ['ordermanagement'],
				notetemplatelist: [],
				tempnotice: {
					note_title: '',
					note_text: '',
				},
				isvisible: false,
				istitle: '',


			}
		},
		created: function() {
			this.initialize();
		},
		methods: {
			edit(item) {
				this.istitle = '编辑模板';
				this.tempnotice = JSON.parse(JSON.stringify(item));
				this.isvisible = true;
			},
			initialize() {
				var self = this;
				this.$axios.get('/trade/notetemplate/get').then(function(res) {
					self.notetemplatelist = res.data.notetemplate;
				});
			},
			del(item) {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否删除',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/notetemplate/delete', {
							params: {
								item: item
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						});
					},
					onCancel() {},
				});

			},
			creatnotice() {
				this.istitle = '新增模板';
				this.tempnotice = {
					note_title: '',
					note_text: '',
				};
				this.isvisible = true;
			},
			onCancel() {
				this.isvisible = false;
			},
			onOk(item) {
				if (item.note_title == "") {
					return this.$message.error("模板名称不能为空");
				}
				if (item.note_text == '') {
					return this.$message.error("内容不能为空");
				}
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/notetemplate/edit', {
							params: {
								item: item
							}
						}).then(function(res) {
							self.isvisible = false;
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
						});
					},
					onCancel() {},
				});
			},

		},

	};
</script>

<style>
	.notetemplate .contentcard {
		position: relative;
		min-width: 900px;
	}

	.notetemplate .contentcard .carditem {
		display: inline-block;
		margin: 0 10px 10px;
		width: 370px;
		height: 180px;
		border-radius: 10px;
		background-color: white;
		position: relative;
		overflow: hidden;
	}

	.notetemplate .ant-card-actions {
		border: none;
		background-color: #1890ff;
	}

	.notetemplate .ant-card-actions span {
		color: white;
	}
</style>



// WEBPACK FOOTER //
// index.vue?4be1846c